import { useId, type ReactNode } from "react";
import { Link } from "react-router";

type Metadata = { label: string; value: ReactNode };

export function MobileDataCard({ title, eyebrow, status, metadata, href, actions }: { title: string; eyebrow?: string; status?: ReactNode; metadata: Metadata[]; href?: string; actions?: ReactNode }) {
  const titleId = useId();
  const content = <article className="ui-mobile-card" aria-labelledby={titleId}>
    <header>{eyebrow ? <span>{eyebrow}</span> : null}<h2 id={titleId}>{title}</h2>{status}</header>
    <dl>{metadata.map((item) => <div key={item.label}><dt>{item.label}</dt><dd>{item.value}</dd></div>)}</dl>
    {actions ? <footer>{actions}</footer> : null}
  </article>;
  return href ? <Link className="ui-mobile-card-link" to={href}>{content}</Link> : content;
}
